angular.module('wbDirectives').directive "wbCompileHtml",
['$parse', '$sce', '$compile', ($parse, $sce, $compile) ->
  restrict: 'A'
  link: ($scope, $el, $attrs) ->
    expression = $sce.parseAsHtml($attrs.wbCompileHtml)

    getResult = -> expression($scope)

    $scope.$watch getResult, (newValue) ->
      linker = $compile(newValue)
      $el.append(linker($scope))
]
